import { LastUsedCounter, PlaytesterV2State } from '../types'

export const getLastUsedCounter = (
  state: PlaytesterV2State,
  changes: Partial<PlaytesterV2State> = {},
): LastUsedCounter => {
  if (changes.lifeTotal && changes.lifeTotal !== state.startingLifeTotal) return 'lifeTotal'

  if (changes.infectDamage) return 'infectDamage'
  if (changes.experiance) return 'experiance'
  if (changes.energy) return 'energy'
  if (changes.whiteMana) return 'whiteMana'
  if (changes.blueMana) return 'blueMana'
  if (changes.blackMana) return 'blackMana'
  if (changes.redMana) return 'redMana'
  if (changes.greenMana) return 'greenMana'
  if (changes.colorlessMana) return 'colorlessMana'

  return state.lastUsedCounterLabel
}
